<template>
  <v-container fluid class="property-management mt-4 px-1">
    <v-row>
      <v-col cols="12">
        <v-card class="mb-1">
          <v-card-title class="pa-5 pb-3">
            <p>Properties</p><span class="grey--text font-weight-regular subtitle-2 pt-1">{{'\xa0 (' +  properties.length }} total) </span>
            <v-spacer></v-spacer>
            <div>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                class="search"
              ></v-text-field>
            </div>
          </v-card-title>
          <v-card-text class="px-5">
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="property-table"
              show-select
              :headers="headers"
              :items="properties"
              :search="search"
              :sort-by="['Name']">
              <template v-slot:top>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      v-bind="attrs"
                      v-on="on"
                    >Add Property</v-btn>
                  </template>
                  <v-card class="edit-dialog">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined v-model="editedItem.title" label="Product name"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined v-model="editedItem.subtitle" label="Subtitle"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field outlined v-model="editedItem.price" label="Price"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field :rules="ratingRules" outlined v-model="editedItem.rating" type="number" label="Rating"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-select outlined :items="images" v-model="editedItem.img" label="Image">
                              <template v-slot:item="{ item }">
                                <v-img :src="item" width="50" style="margin: 2px"></v-img>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="close">Cancel</v-btn>
                      <v-btn color="success" class="button-shadow" @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>>
              <template v-slot:item.api="{ item }">
                <v-btn
                  class="mr-3 button-shadow"
                  @click="editItem(item)"
                  small
                  color="success"
                >Edit
                </v-btn>
                <v-btn
                  @click="deleteItem(item)"
                  small
                  class="button-shadow"
                  color="secondary"
                >Delete
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
        v-model="snackbar"
        color="success"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import config from "@/config";
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'PropertyManagement',
    data() {
      return {
        snackbar: null,
        search: '',
        dialog: false,
        headers: [
          {
            text: 'Name',
            align: 'start',
            value: 'name',
          },
          { text: 'Address', value: 'address', sortable: false },
          { text: 'Owner', value: 'owner' },
          { text: 'Cleaner', value: 'cleaner' },
          { text: 'Status', value: 'status' },
          { text: 'Entry', value: 'entry'},
          { text: 'HOT Number', value: 'hot' },
          { text: 'Actions', value: 'api', sortable: false },
        ],
        selected: [],
        editedIndex: -1,
        editedItem: {
          name: '',
          address: '',
          owner: '',
          cleaner: '',
          status: '',
          entry: '',
          hot: '',
        },
        defaultItem: {
          name: '',
          address: '',
          owner: '',
          cleaner: '',
          status: '',
          entry: '',
          hot: '',
        },
        notification: '',
      }
    },
    computed: {
        ...mapState('properties', ['properties', "isReceiving", "isDeleting", "idToDelete", "propertyMessage", "isUpdating"]),
        formTitle () {
          return this.editedIndex === -1 ? 'New Property' : 'Edit Property'
        },
      },
    watch: {
      dialog (val) {
          val || this.close()
        },
      propertyMessage() {
        if (this.propertyMessage !== '') {
          this.notification = this.propertyMessage
          this.addSuccessNotification()
        }
      }
    },
    created () {
        this.addSuccessNotification()
      },
    mounted() {
      this.getPropertiesRequest()
    },
    methods: {
      ...mapActions('properties',
        [
          "getPropertiesRequest",
          "deletePropertyRequest",
          "updatePropertyRequest",
          "createPropertyRequest"
        ]
      ),
      editItem (item) {
        this.editedIndex = this.properties.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        if (!config.isBackend ) {
          confirm('Are you sure you want to delete this item?') && this.products.splice(item.id, 1)
        } else {
          confirm('Are you sure you want to delete this item?') && this.deleteProductRequest({id: item.id})
        }
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        if (this.editedIndex > -1) {
          !config.isBackend ?
          Object.assign(this.properties[this.editedIndex], this.editedItem)
          :
          this.updatePropertyRequest(this.editedItem)
        } else {
          !config.isBackend ?
          this.properties.push(this.editedItem)
          :
          this.createPropertyRequest(this.editedItem)
        }
        this.close()
      },
      addSuccessNotification() {
        this.snackbar = true;
        this.color = config.light.success;
        this.text = this.notification;
      },
    },
  }
</script>

<style src="./Properties.scss" lang="scss"/>
